import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { CheckUtils, EncryptStorageEvent, PageScrollerVoData, PagesModel, PageVoData } from "../..";
var PagesProvider = /** @class */ (function () {
    function PagesProvider(_model, _events) {
        this._model = _model;
        this._events = _events;
        this._scrollTimers = new Map();
        this.bind();
    }
    PagesProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        });
    };
    Object.defineProperty(PagesProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    PagesProvider.prototype.setPage = function (value) {
        if (!CheckUtils.isEmpty(value) && this._model.page !== value && this._model.isLoaded) {
            this._model.setPage(value);
        }
    };
    PagesProvider.prototype.setContext = function (value) {
        if (this._model.context !== value) {
            this._model.setContext(value);
        }
    };
    PagesProvider.prototype.getScroll = function (conversationsPage, scrollName) {
        var page = this._model.get(conversationsPage);
        if (CheckUtils.isEmpty(page))
            return null;
        for (var _i = 0, _a = page.scrollers; _i < _a.length; _i++) {
            var scroller = _a[_i];
            if (scroller.name === scrollName)
                return scroller;
        }
    };
    PagesProvider.prototype.setScroll = function (pageName, scrollName, scrollLeft, scrollTop) {
        var _this = this;
        if (this._scrollTimers.has(pageName + ":" + scrollName))
            clearTimeout(this._scrollTimers.get(pageName + ":" + scrollName));
        var scrollTimer = setTimeout(function () {
            var page = _this._model.get(pageName);
            if (CheckUtils.isEmpty(page))
                page = new PageVoData(pageName);
            var updated;
            for (var _i = 0, _a = page.scrollers; _i < _a.length; _i++) {
                var scroller = _a[_i];
                if (scroller.name === scrollName) {
                    scroller.x = scrollLeft, scroller.y = scrollTop;
                    updated = true;
                    break;
                }
            }
            if (!updated) {
                var scroller = new PageScrollerVoData();
                scroller.name = scrollName;
                scroller.x = scrollLeft, scroller.y = scrollTop;
                page.scrollers.push(scroller);
            }
            _this._model.add(page);
            _this._scrollTimers.delete(pageName + ":" + scrollName);
        }, 500);
        this._scrollTimers.set(pageName + ":" + scrollName, scrollTimer);
    };
    PagesProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    PagesProvider.ctorParameters = function () { return [
        { type: PagesModel, },
        { type: Events, },
    ]; };
    return PagesProvider;
}());
export { PagesProvider };
//# sourceMappingURL=pages-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/page/pages-provider.js
// module id = 367
// module chunks = 14